'use client'

import '@glidejs/glide/dist/css/glide.core.min.css'

import Glide from '@glidejs/glide'
import React, { useEffect, useRef } from 'react'
import { Href } from 'components/navigation'

// const CardSkeleton: React.FC<{ className?: string }> = ({ className }) => {
//   return <div className={cx('bone h-[12.125rem] w-full', className)} />
// }

type CardProps = {
  banner: any
}

const Card: React.FC<CardProps> = ({ banner }) => {
  return (
    <>
      <Href
        className="bg-card-border-bottom overflow-hidden"
        href={banner.link}
        target="_blank"
        id={`gtm_billboard_${banner.title}`}
      >
        <div
          className="mb:h-[96px] h-[280px] wd:h-[216px] aspect-[4:1] bg-center bg-cover bg-no-repeat mb:mx-2"
          style={{
            backgroundImage: `url(${banner.image})`,
          }}
        />
      </Href>
    </>
  )
}

const sliderConfiguration = {
  gap: 8,
  perView: 1,
  startAt: 0,
  focusAt: 0,
  autoplay: 5000,
  bound: true,
  breakpoints: {
    802: {
      perView: 1,
    },
  },
}

const Banners: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  const bannerData = [
    {
      id: 1,
      title: 'deposit_bonus',
      description: 'Visit the page to see the details',
      link: 'https://dgbet.fun/contests/deposit-bonus',
      image: '/images/illustrations/deposit_bonus.webp',
    },
    {
      id: 2,
      title: 'goalfest',
      description: 'Visit the page to see the details',
      link: 'https://dgbet.fun/contests/dgbet-goalfest',
      image: '/images/illustrations/goal_fest.webp',
    },
    {
      id: 3,
      title: 'allstars',
      description: 'Visit the page to see the details',
      link: 'https://dgbet.fun/contests/dgbet-allstars',
      image: '/images/illustrations/all_stars.webp',
    },
    {
      id: 4,
      title: 'cashback',
      description: 'Visit the page to see the details',
      link: 'https://dgbet.fun/contests/cashback',
      image: '/images/illustrations/cashback.webp',
    },
    {
      id: 5,
      title: 'icons',
      description: 'Visit the page to see the details',
      link: 'https://dgbet.fun/contests/dgbet-icons-club',
      image: '/images/illustrations/dgbet_Icons.webp',
    },
    // {
    //   id: 6,
    //   title: 'affiliate',
    //   description: 'Visit the page to see the details',
    //   link: 'https://dgbet.fun/affiliates',
    //   image: '/images/illustrations/affiliate_program_banner.webp',
    // },
  ]

  useEffect(() => {
    if (!bannerData?.length) {
      return
    }

    const slider = new Glide(containerRef.current, sliderConfiguration)

    slider.mount()

    return () => {
      slider?.destroy()
    }
  }, [bannerData])

  return (
    <div ref={containerRef} className="glide !static group">
      <div className="glide__track" data-glide-el="track">
        <ul className="glide__slides">
          {bannerData?.map((banner, index) => (
            <li key={index} className="glide__slide overflow-hidden">
              <Card banner={banner} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

const PromoBanner: React.FC = () => {
  return (
    <div className="relative">
      <Banners />
    </div>
  )
}

export default PromoBanner

{
  /* <div className="bg-card-border-bottom overflow-hidden mb:hidden block">
        <div
          className="h-[280px] wd:h-[216px] aspect-[4:1] bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${banner.image})`,
          }}
        >
          <div className="w-full h-full p-7 flex flex-col justify-end">

            <Button
              size={32}
              className="w-fit"
              href={banner.link}
              target="_blank"
            >
              Click Now
            </Button>
          </div>
        </div>
      </div> */
}
